import React from 'react';
import { motion } from 'framer-motion';
import { Download, Search, HeartPulse } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download size={32} data-id="element-75" />,
    title: '1. Descargás la guía',
    desc: 'Tenés el PDF en tu celular listo para abrir incluso sin internet.'
  }, {
    icon: <Search size={32} data-id="element-76" />,
    title: '2. Identificás el riesgo',
    desc: 'Usás el Protocolo Semáforo ante cualquier síntoma extraño.'
  }, {
    icon: <HeartPulse size={32} data-id="element-77" />,
    title: '3. Actuás con precisión',
    desc: 'Seguís las instrucciones de estabilización y vas a la guardia con la información que el veterinario necesita.'
  }];
  return <section className="py-12 px-4 bg-neutral-950" data-id="element-78">
      <div className="container mx-auto max-w-5xl" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-80">
          <h2 className="text-5xl md:text-6xl font-display text-white mb-4" data-id="element-81">
            ¿Cómo funciona?
          </h2>
          <p className="text-xl text-neutral-400" data-id="element-82">
            Tres pasos simples para salvar una vida.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-83">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-neutral-800 z-0" data-id="element-84" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-85">
              <div className="w-24 h-24 rounded-full bg-neutral-900 border-4 border-neutral-950 shadow-[0_0_0_2px_rgba(255,107,0,0.3)] flex items-center justify-center text-brand mb-6" data-id="element-86">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-87">
                {step.title}
              </h3>
              <p className="text-neutral-400 text-lg leading-relaxed max-w-xs" data-id="element-88">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}